export const CATEGORY_OPTIONS = [
  { value: "bug", labelKey: "feedback.cat_bug" },
  { value: "feature", labelKey: "feedback.cat_feature" },
  { value: "docs", labelKey: "feedback.cat_docs" },
  { value: "business_rule", labelKey: "feedback.cat_business_rule" },
  { value: "log", labelKey: "feedback.cat_log" },
  { value: "other", labelKey: "feedback.cat_other" },
];

export const STATUS_OPTIONS = [
  {
    value: "pending_validation",
    labelKey: "feedback.status_pending_validation",
  },
  { value: "open", labelKey: "feedback.status_open" },
  { value: "completed", labelKey: "feedback.status_completed" },
];

export const ALL_DISPLAY_STATUSES = [
  {
    value: "pending_validation",
    labelKey: "feedback.status_pending_validation",
  },
  { value: "open", labelKey: "feedback.status_open" },
  { value: "completed", labelKey: "feedback.status_completed" },
  { value: "archived", labelKey: "feedback.status_archived" },
];

export const STATUS_PRIORITY = {
  pending_validation: 0,
  open: 1,
  completed: 2,
  archived: 3,
};

const FOURTEEN_DAYS_MS = 14 * 24 * 60 * 60 * 1000;

export function getDisplayStatus(topic) {
  if (topic.status === "completed") {
    const updatedAt = new Date(topic.updated_at).getTime();
    if (Date.now() - updatedAt > FOURTEEN_DAYS_MS) return "archived";
  }
  return topic.status;
}
